import React, { Component } from "react";
import CartContext from "./CartContext";
import { Carousel, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Showcase } from "./Showcase";
import { DemoLinks } from "./Home";
import { ECommerceFeatures, ECommercePricing } from "./Pricing";
import { DigitalMarketingPricing } from "./Pricing";

import {
  RestaurantPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  ErpRetail,
  LeadsManagementModule,
  CouponsManagementModule,
  ECommerceB2CModule,
  ECommerceB2cRestaurantModule,
  KdsModule,
  RecipeManagementModule,
} from "./CommonModules";

export class ECommerceB2CRestaurant extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      stores: [
        {
          name: "restaurant.png",
          title: "Online Restaurant Shop",
          url: "https://restaurant.elasticcart.com",
        },
        {
          name: "vegrestaurant.png",
          title: "Online Veg Restaurant Shop",
          url: "https://vegrestaurant.elasticcart.com",
        },
      ],
    };
  }

  handleSelect = (selectedIndex) => {
    this.setState({ index: selectedIndex });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <div className="container-fluid py-5 bg-white">
        <div className="container">
          <div className="row gx-5">
            <div className="col-12 border-start border-5 border-primary ps-3 mb-lg-1">
              <h6 className="text-primary text-uppercase">
                Product & Features
              </h6>

              <Col md={11}>
                <h2 className="display-6 text-dark">
                  Online Shop for Restaurant Business - ECommerce B2C{" "}
                </h2>
              </Col>
              <Col className="text-end">
                <Button
                  as={Link}
                  variant="warning"
                  to="/Checkout"
                  onClick={() => {
                    if (this.context.userData.loginStatus !== "active") {
                      this.context.ShowUserLoginNew(true);
                    }
                    this.context.SetSelectedProduct(
                      this.context.prods.find(
                        (f) =>
                          f.productType ===
                          this.context.ProductType.ECommerce_B2C_Restaurant
                      )
                    );
                  }}
                >
                  Try Free / Buy
                </Button>
              </Col>
            </div>
          </div>
          <p className="text-muted lead ">
            We provide a complete solution for your online Restaurant, from
            product management to payment processing. Our platform is easy to
            use and customizable to fit your needs. Whether you're a small or
            large business, we have the tools to help you succeed in the online
            marketplace. Our E-Commerce B2C platform is designed to help you
            reach your customers and grow your business. With features like
            product easy checkout, SMS based OTP authentication, and a
            user-friendly interface, you can create a seamless shopping
            experience for your customers. Our platform is built to scale with
            your business, so you can focus on what you do best - selling your
            products. Try it free today and see the difference! <br />
          </p>

          <div className="col-lg-12 mb-lg-5">
            <video
              controls
              height="400px"
              autoPlay
              muted
              loop
              width="100%"
              // className="rounded shadow"
              aria-label="POS software demo video"
            >
              <source
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "EcommerceRestaurantB2cVideo.mp4"
                }
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="py-5 text-center">
            <h1> Modal Business Sites</h1>
            <Carousel
              fade
              activeIndex={this.state.index}
              onSelect={this.handleSelect}
            >
              {this.state.stores.map((store, idx) => (
                <Carousel.Item key={idx} interval={3000}>
                  <div className="bg-white border CornersRoundedBig p-4 text-center ">
                    <h3 className="text-dark mb-3">{store.title}</h3>
                    <a
                      href={store.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={`https://ecprdstorage01.blob.core.windows.net/elasticcart/images/${store.name}`}
                        alt={store.title}
                        className="img-fluid rounded"
                        style={{ maxHeight: "350px", objectFit: "contain" }}
                      />
                    </a>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>

          <div className="py-5 rounded h-100">
            <Row>
              <Col md={6}>
                <h5 className="display-6 text-dark mb-3">Key Features</h5>
                <Button
                  as={Link}
                  variant="warning"
                  to="/Checkout"
                  onClick={() => {
                    if (this.context.userData.loginStatus !== "active") {
                      this.context.ShowUserLoginNew(true);
                    }
                    this.context.SetSelectedProduct(
                      this.context.prods.find(
                        (f) =>
                          f.productType ===
                          this.context.ProductType.ECommerce_B2C_Restaurant
                      )
                    );
                  }}
                >
                  Try Free / Buy
                </Button>
              </Col>
              <Col></Col>
            </Row>

            <Row className="g-3 mt-4 CornersRoundedMedium bg-light p-4 shadow-sm">
              <Col xs={12} md={6}>
                <ul className="list-unstyled small text-muted">
                  <li>✔ Free SSL and Custom domain</li>
                  <li>✔ Premium & Custom Themes</li>
                  <li>✔ OTP Authentication (SMS/Email)</li>
                  <li>✔ Payment Gateway, COD, Manual UPI</li>
                  <li>✔ Product Variants, Multi-Image, Video</li>
                  <li>✔ Discounts, Wishlists, Smart Cart</li>
                  <li>✔ Customer visited products</li>
                </ul>
              </Col>
              <Col xs={12} md={6}>
                <ul className="list-unstyled small text-muted">
                  <li>✔ Vlogs & Blogs Integration</li>
                  <li>✔ Marketing ads, SEO, and Social Media</li>
                  <li>✔ Notifications: Email, WhatsApp, Abandoned Cart</li>
                  <li>✔ Multi-Store, Multi-Vendor, Multi-Currency</li>
                  <li>✔ Product Reviews, Ratings, and Comments</li>
                  <li>✔ Customer Groups, Memberships, and Subscriptions</li>
                  <li>✔ Analytics, Reports, Customer Dashboard</li>
                </ul>
              </Col>
            </Row>
          </div>

          {/* ERP Modules Section */}
          <section className="container my-5">
            <h5 className="display-6 text-dark mb-4">
              Explore Integrated ERP Modules That Power Your Business
            </h5>
            <Row className="g-3">
              {[
                ECommerceB2cRestaurantModule,
                InventoryModule,
                PurchasesModule,
                OrdersManagementModule,
                KdsModule,
                RecipeManagementModule,
                DeliveryManagementModule,
                CrmModule,
                CouponsManagementModule,
                HrmModule,
                AccountingModule,
                ReportsModule,
              ].map((Module, index) => (
                <Col md={6} lg={6} key={index}>
                  <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                    <Module />
                  </div>
                </Col>
              ))}
            </Row>
          </section>
        </div>
      </div>
    );
  }
}
